import { Component, inject } from '@angular/core';

import { LanguageService } from '../../../core/services/language.service';

@Component({
  selector: 'demo-language-switcher',
  standalone: true,
  template: `
    <button
      type="button"
      class="demo-lang-switcher"
      (click)="language.toggle()"
      [attr.aria-label]="'Cambiar idioma'"
    >
      {{ language.lang() === 'es' ? 'EN' : 'ES' }}
    </button>
  `,
  styles: [
    `
      .demo-lang-switcher {
        background: transparent;
        border: 1px solid var(--demo-line);
        border-radius: var(--demo-radius-sm);
        color: var(--demo-ink);
        padding: 0.5em 0.75em;
        font-size: 0.85rem;
        font-weight: 600;
        cursor: pointer;
      }
      .demo-lang-switcher:hover {
        background: var(--demo-sand);
      }
    `,
  ],
})
export class LanguageSwitcherComponent {
  protected readonly language = inject(LanguageService);
}
